import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { IMessageDeliveryData } from '../message-delivery/message-delivery.interface';
import {
  fetchEligibleClients,
  fetchReviewDetail,
  fetchReviews,
  fetchReviewSettings,
  fetchReviewSummary,
  requestReview,
  resetRequestReview,
  saveReviewSettingsNetwork,
  sendRequestReview,
} from './review-data.actions';
import { IReviewSettings } from './review-data.data';

@Injectable()
export class ReviewDataDispatcher {
  constructor(private _store: Store<any>) {}

  fetchReviews() {
    this._store.dispatch(fetchReviews());
  }

  fetchEligibleClients() {
    this._store.dispatch(fetchEligibleClients());
  }

  fetchReviewSummary() {
    this._store.dispatch(fetchReviewSummary());
  }

  fetchReviewDetail(reviewId: string) {
    this._store.dispatch(fetchReviewDetail(reviewId));
  }

  requestReview(clientId: string) {
    this._store.dispatch(requestReview(clientId));
  }

  resetRequestReview() {
    this._store.dispatch(resetRequestReview());
  }

  sendRequestReview(
    reviewRequestId: number,
    messageData: IMessageDeliveryData,
    clientEmail: string
  ) {
    this._store.dispatch(
      sendRequestReview(reviewRequestId, messageData, clientEmail)
    );
  }

  fetchReviewSettings() {
    this._store.dispatch(fetchReviewSettings());
  }

  saveReviewSettings(settings: IReviewSettings) {
    this._store.dispatch(saveReviewSettingsNetwork(settings));
  }
}
